import "./style.scss";

import StyledButton from "../StyledButton";

interface SaveButton {
    onSave: () => void | Promise<void>;
    buttonText: string;
    loading?: boolean;
    disabled?: boolean;
}

const SaveButton = ({ onSave, buttonText, loading = false, disabled = false }: SaveButton) => {
    return (
        <div className="save-button-container">
            <StyledButton
                className="save-button"
                onClick={() => onSave()}
                loading={loading}
                disabled={disabled || loading}
            >
                {buttonText}
            </StyledButton>
        </div>
    );
};

export default SaveButton;
